<template>
  <div style="width:1000px; margin:0 auto"> 
 <img style="width:100%;margin:0" src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230721/user-0/20230721/c239bbb76dfd0c966fe0ba30aba1742f.jpg?x-oss-process=style/tb-750" />
    <!-- <img style="width:100%;margin:0" src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230721/user-0/20230721/492a9c3d8220166be1810f9ecfc19648.jpg?x-oss-process=style/tb-750" /> -->
 
  </div>
</template>
<script> 

export default {
  name: "IndexIndex",
  data() {
    return {  
      }
  },
  mounted() {
    // this.getnotice();
    // this.getcourse();

    document.title = "中国蹦床与技巧协会啦啦操分会官方 啦啦操官方网站"
    document.querySelector('meta[name="description"]').setAttribute('content','中国蹦床与技巧协会啦啦操分会（CCA）是在国家体育总局体操运动管理中心和中国蹦床与技巧协会的指导和监督下，负责管理全国啦啦操项目的唯一机构。')
 
  },
  filters: { 
  },
  methods: { 
  },
  components: { 
  },
};
</script>
<style lang="scss" scoped> 
</style>



// WEBPACK FOOTER //
// IndexUpdate.vue?7bb8a0a4